


// // import React, { useState, useEffect, useRef } from 'react';
// // import FurnitureNavbar from '../../../components/layout/Nav';
// // import '../../buyer/profile/profile.scss';
// // import withAuth from '../../auth/WithAuth';
// // import defaultAvatar from '../../../assets/DefaultProfile.png';
// // import {
// //   FaUser,
// //   FaEnvelope,
// //   FaPhone,
// //   FaLock,
// //   FaCamera,
// //   FaCheck,
// //   FaExclamationTriangle,
// //   FaEdit,
// //   FaTimes,
// //   FaTrash,
// //   FaArrowRight,
// //   FaCrop,
// //   FaTimesCircle,
// // } from 'react-icons/fa';
// // import Button from 'react-bootstrap/Button';
// // import Form from 'react-bootstrap/Form';
// // import Alert from 'react-bootstrap/Alert';
// // import Modal from 'react-bootstrap/Modal';
// // import { serverUrlAuth } from '../../../serverUrl';
// // import { useNavigate } from 'react-router-dom';
// // import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
// // import 'react-image-crop/dist/ReactCrop.css';

// // const ClientProfile = () => {
// //   const navigate = useNavigate();
// //   const [activeTab, setActiveTab] = useState('profile');
// //   const [profile, setProfile] = useState({
// //     name: '',
// //     email: '',
// //     phone: '',
// //     avatar: defaultAvatar,
// //   });
// //   const [originalProfile, setOriginalProfile] = useState(profile);
// //   const [editable, setEditable] = useState(false);
// //   const [password, setPassword] = useState({
// //     current: '',
// //     new: '',
// //     confirm: '',
// //   });
// //   const [alerts, setAlerts] = useState({ profile: '', password: '' });
// //   const [isLoading, setIsLoading] = useState(false);
// //   const fileInputRef = useRef(null);

// //   // Crop state
// //   const [showCropModal, setShowCropModal] = useState(false);
// //   const [selectedImage, setSelectedImage] = useState(null);
// //   const [crop, setCrop] = useState({
// //     unit: '%',
// //     width: 80,
// //     height: 80,
// //     x: 10,
// //     y: 10,
// //   });
// //   const [completedCrop, setCompletedCrop] = useState(null);
// //   const [croppedImageUrl, setCroppedImageUrl] = useState(null);
// //   const imgRef = useRef(null);

// //   // Fetch user profile
// //   useEffect(() => {
// //     const fetchProfile = async () => {
// //       try {
// //         const res = await serverUrlAuth.get('users/profile/');
// //         const data = res.data;
// //         const initialProfile = {
// //           name: data.full_name,
// //           email: data.email,
// //           phone: data.phone_number || '',
// //           avatar: data.profile_picture || defaultAvatar,
// //         };
// //         setProfile(initialProfile);
// //         setOriginalProfile(initialProfile);
// //       } catch (error) {
// //         console.error(error);
// //       }
// //     };
// //     fetchProfile();
// //   }, []);

// //   const toggleEdit = () => setEditable(true);

// //   const cancelEdit = () => {
// //     setProfile(originalProfile);
// //     setEditable(false);
// //   };

// //   const handleDeleteAccountClick = () => {
// //     navigate('/delete-account');
// //   };

// //   const handleProfileChange = (e) => {
// //     const { name, value } = e.target;
// //     setProfile((prev) => ({ ...prev, [name]: value }));
// //   };

// //   // Handle image selection and open crop modal
// //   const handleAvatarChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       if (!file.type.startsWith('image/')) {
// //         showAlert('profile', 'Please select a valid image', 'error');
// //         return;
// //       }
// //       if (file.size > 5 * 1024 * 1024) {
// //         showAlert('profile', 'Image must be less than 5MB', 'error');
// //         return;
// //       }

// //       const reader = new FileReader();
// //       reader.onload = () => {
// //         setSelectedImage(reader.result);
// //         setShowCropModal(true);
// //         // Reset crop when new image is loaded
// //         setCrop({
// //           unit: '%',
// //           width: 80,
// //           height: 80,
// //           x: 10,
// //           y: 10,
// //         });
// //         setCompletedCrop(null);
// //         setCroppedImageUrl(null);
// //       };
// //       reader.readAsDataURL(file);
// //       // Reset file input so same file can be selected again
// //       e.target.value = null;
// //     }
// //   };

// //   const triggerFileInput = () => editable && fileInputRef.current?.click();

// //   // Handle crop completion
// //   const onCropComplete = (crop) => {
// //     setCompletedCrop(crop);
// //   };

// //   // Generate cropped image
// //   const getCroppedImg = async () => {
// //     if (!imgRef.current || !completedCrop) {
// //       return;
// //     }

// //     try {
// //       const canvas = document.createElement('canvas');
// //       const image = imgRef.current;
// //       const crop = completedCrop;

// //       const scaleX = image.naturalWidth / image.width;
// //       const scaleY = image.naturalHeight / image.height;

// //       canvas.width = crop.width * scaleX;
// //       canvas.height = crop.height * scaleY;

// //       const ctx = canvas.getContext('2d');

// //       ctx.imageSmoothingEnabled = true;
// //       ctx.imageSmoothingQuality = 'high';

// //       ctx.drawImage(
// //         image,
// //         crop.x * scaleX,
// //         crop.y * scaleY,
// //         crop.width * scaleX,
// //         crop.height * scaleY,
// //         0,
// //         0,
// //         crop.width * scaleX,
// //         crop.height * scaleY
// //       );

// //       // Convert canvas to blob
// //       return new Promise((resolve) => {
// //         canvas.toBlob((blob) => {
// //           if (blob) {
// //             const url = URL.createObjectURL(blob);
// //             resolve(url);
// //           }
// //         }, 'image/jpeg', 0.95);
// //       });
// //     } catch (error) {
// //       console.error('Error cropping image:', error);
// //       showAlert('profile', 'Failed to crop image', 'error');
// //     }
// //   };

// //   // Apply crop and close modal
// //   const applyCrop = async () => {
// //     if (!completedCrop) {
// //       showAlert('profile', 'Please crop the image first', 'error');
// //       return;
// //     }

// //     try {
// //       const croppedImage = await getCroppedImg();
// //       if (croppedImage) {
// //         setCroppedImageUrl(croppedImage);
// //         setProfile((prev) => ({ ...prev, avatar: croppedImage }));
// //         showAlert('profile', 'Avatar cropped successfully!', 'success');
// //         setShowCropModal(false);
// //       }
// //     } catch (error) {
// //       console.error('Error applying crop:', error);
// //       showAlert('profile', 'Failed to apply crop', 'error');
// //     }
// //   };

// //   // Cancel crop modal
// //   const cancelCrop = () => {
// //     setShowCropModal(false);
// //     setSelectedImage(null);
// //     setCroppedImageUrl(null);
// //     setCompletedCrop(null);
// //   };

// //   const handlePasswordChange = (e) => {
// //     const { name, value } = e.target;
// //     setPassword((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const showAlert = (type, message, variant = 'success') => {
// //     setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
// //     setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
// //   };

// //   const saveProfile = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);

// //     try {
// //       const formData = new FormData();
// //       formData.append('full_name', profile.name);
// //       formData.append('phone_number', profile.phone);

// //       // If we have a cropped image, convert it to file and upload
// //       if (croppedImageUrl) {
// //         try {
// //           const response = await fetch(croppedImageUrl);
// //           const blob = await response.blob();
// //           const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
// //           formData.append('profile_picture', file);
// //         } catch (error) {
// //           console.error('Error converting cropped image:', error);
// //           showAlert('profile', 'Error processing image', 'error');
// //           setIsLoading(false);
// //           return;
// //         }
// //       } else if (fileInputRef.current?.files[0]) {
// //         formData.append('profile_picture', fileInputRef.current.files[0]);
// //       }

// //       const res = await serverUrlAuth.patch('users/profile/', formData, {
// //         headers: { 'Content-Type': 'multipart/form-data' },
// //       });

// //       const updatedProfile = {
// //         ...profile,
// //         avatar: res.data.profile_picture || profile.avatar,
// //       };

// //       setProfile(updatedProfile);
// //       setOriginalProfile(updatedProfile);
// //       setCroppedImageUrl(null); // Reset cropped image after save
// //       showAlert('profile', 'Profile updated successfully!', 'success');
// //       setEditable(false);
// //     } catch (error) {
// //       console.error(error);
// //       showAlert('profile', 'Failed to update profile', 'error');
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const savePassword = async (e) => {
// //     e.preventDefault();
// //     if (password.new.length < 8)
// //       return showAlert(
// //         'password',
// //         'Password must be at least 8 characters',
// //         'error',
// //       );
// //     if (password.new !== password.confirm)
// //       return showAlert('password', "Passwords don't match!", 'error');

// //     setIsLoading(true);
// //     await new Promise((resolve) => setTimeout(resolve, 1000));
// //     setIsLoading(false);
// //     showAlert('password', 'Password changed successfully!', 'success');
// //     setPassword({ current: '', new: '', confirm: '' });
// //   };

// //   // Cleanup object URLs on unmount
// //   useEffect(() => {
// //     return () => {
// //       if (croppedImageUrl) {
// //         URL.revokeObjectURL(croppedImageUrl);
// //       }
// //     };
// //   }, [croppedImageUrl]);

// //   return (
// //     <>
// //       <FurnitureNavbar />
// //       <div className="profile-page">
// //         <div className="profile-layout">
// //           <div className="vertical-tabs">
// //             <button
// //               className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
// //               onClick={() => setActiveTab('profile')}
// //             >
// //               <FaUser className="tab-icon" /> Profile Information
// //             </button>
// //             {/* <button
// //               className={`tab-btn ${activeTab === 'password' ? 'active' : ''}`}
// //               onClick={() => setActiveTab('password')}
// //             >
// //               <FaLock className="tab-icon" /> Change Password
// //             </button> */}
// //             {/* Delete Account Tab - Navigates to /delete-account */}
// //             <button
// //               className="tab-btn delete-tab"
// //               onClick={handleDeleteAccountClick}
// //             >
// //               <FaTrash className="tab-icon" /> Delete Account
// //               <FaArrowRight className="tab-arrow" />
// //             </button>
// //           </div>

// //           <div className="profile-content">
// //             {alerts.profile && (
// //               <Alert variant={alerts.profile.variant} className="alert-custom">
// //                 {alerts.profile.variant === 'success' ? (
// //                   <FaCheck />
// //                 ) : (
// //                   <FaExclamationTriangle />
// //                 )}
// //                 {alerts.profile.message}
// //               </Alert>
// //             )}

// //             {activeTab === 'profile' && (
// //               <div className="profile-card">
// //                 <div className="card-header">
// //                   <h3>Profile Information</h3>
// //                   <p>Update your personal details and avatar</p>
// //                 </div>

// //                 <div className="card-content">
// //                   <div className="avatar-section">
// //                     <div className="avatar-preview">
// //                       <img src={profile.avatar} alt="Profile Avatar" />
// //                     </div>
// //                     {editable && (
// //                       <>
// //                         <Button
// //                           className="change-avatar"
// //                           onClick={triggerFileInput}
// //                         >
// //                           <FaCamera /> Change Profile Photo
// //                         </Button>
// //                         <input
// //                           type="file"
// //                           ref={fileInputRef}
// //                           onChange={handleAvatarChange}
// //                           accept="image/*"
// //                           style={{ display: 'none' }}
// //                         />
// //                       </>
// //                     )}
// //                   </div>

// //                   <div className="info-section">
// //                     <Form onSubmit={saveProfile}>
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaUser className="input-icon" /> Full Name
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           name="name"
// //                           value={profile.name}
// //                           onChange={handleProfileChange}
// //                           disabled={!editable}
// //                           required
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaEnvelope className="input-icon" /> Email Address
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="email"
// //                           name="email"
// //                           value={profile.email}
// //                           disabled
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaPhone className="input-icon" /> Phone Number
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="tel"
// //                           name="phone"
// //                           value={profile.phone}
// //                           onChange={handleProfileChange}
// //                           disabled={!editable}
// //                         />
// //                       </Form.Group>
// //                       {!editable && (
// //                         <Button
// //                           className="edit-profile"
// //                           size="sm"
// //                           onClick={toggleEdit}
// //                         >
// //                           <FaEdit /> Edit Profile
// //                         </Button>
// //                       )}
// //                       {editable && (
// //                         <div className="form-actions">
// //                           <Button
// //                             className="save-profile"
// //                             type="submit"
// //                             disabled={isLoading}
// //                           >
// //                             {isLoading ? 'Saving...' : 'Save Changes'}
// //                           </Button>
// //                           <Button
// //                             className="cancel-profile"
// //                             variant="secondary"
// //                             onClick={cancelEdit}
// //                             disabled={isLoading}
// //                             style={{ marginLeft: '10px' }}
// //                           >
// //                             <FaTimes /> Cancel
// //                           </Button>
// //                         </div>
// //                       )}
// //                     </Form>
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //             {activeTab === 'password' && (
// //               <div className="profile-card">
// //                 <div className="card-header">
// //                   <h3>Change Password</h3>
// //                   <p>Secure your account with a new password</p>
// //                 </div>
// //                 {alerts.password && (
// //                   <Alert
// //                     variant={alerts.password.variant}
// //                     className="alert-custom"
// //                   >
// //                     {alerts.password.variant === 'success' ? (
// //                       <FaCheck />
// //                     ) : (
// //                       <FaExclamationTriangle />
// //                     )}
// //                     {alerts.password.message}
// //                   </Alert>
// //                 )}
// //                 <div className="card-content password-content">
// //                   <Form onSubmit={savePassword}>
// //                     <Form.Group className="form-group-custom">
// //                       <Form.Label>
// //                         <FaLock className="input-icon" /> Current Password
// //                       </Form.Label>
// //                       <Form.Control
// //                         type="password"
// //                         name="current"
// //                         value={password.current}
// //                         onChange={handlePasswordChange}
// //                         required
// //                       />
// //                     </Form.Group>

// //                     <Form.Group className="form-group-custom">
// //                       <Form.Label>
// //                         <FaLock className="input-icon" /> New Password
// //                       </Form.Label>
// //                       <Form.Control
// //                         type="password"
// //                         name="new"
// //                         value={password.new}
// //                         onChange={handlePasswordChange}
// //                         required
// //                       />
// //                     </Form.Group>

// //                     <Form.Group className="form-group-custom">
// //                       <Form.Label>
// //                         <FaLock className="input-icon" /> Confirm New Password
// //                       </Form.Label>
// //                       <Form.Control
// //                         type="password"
// //                         name="confirm"
// //                         value={password.confirm}
// //                         onChange={handlePasswordChange}
// //                         required
// //                       />
// //                     </Form.Group>

// //                     <div className="form-actions">
// //                       <Button
// //                         variant="warning"
// //                         type="submit"
// //                         disabled={isLoading}
// //                       >
// //                         {isLoading ? 'Updating...' : 'Change Password'}
// //                       </Button>
// //                     </div>
// //                   </Form>
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>

// //       {/* Crop Modal */}
// //       <Modal
// //         show={showCropModal}
// //         onHide={cancelCrop}
// //         size="lg"
// //         centered
// //         backdrop="static"
// //       >
// //         <Modal.Header closeButton>
// //           <Modal.Title>
// //             <FaCrop className="me-2" /> Crop Avatar Image
// //           </Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           <div className="crop-container" style={{ textAlign: 'center' }}>
// //             {selectedImage && (
// //               <ReactCrop
// //                 crop={crop}
// //                 onChange={(c) => setCrop(c)}
// //                 onComplete={onCropComplete}
// //                 aspect={1}
// //                 circularCrop
// //                 className="react-crop"
// //                 style={{ maxHeight: '500px' }}
// //               >
// //                 <img
// //                   ref={imgRef}
// //                   src={selectedImage}
// //                   alt="Crop preview"
// //                   style={{ maxWidth: '100%' }}
// //                   onLoad={() => {
// //                     // Auto-center crop on image load
// //                     const img = imgRef.current;
// //                     if (img) {
// //                       const { width, height } = img;
// //                       const cropSize = Math.min(width, height) * 0.8;
// //                       const cropX = (width - cropSize) / 2;
// //                       const cropY = (height - cropSize) / 2;
// //                       setCrop({
// //                         unit: 'px',
// //                         width: cropSize,
// //                         height: cropSize,
// //                         x: cropX,
// //                         y: cropY,
// //                       });
// //                     }
// //                   }}
// //                 />
// //               </ReactCrop>
// //             )}
// //             <div className="mt-3 text-muted small">
// //               <FaCamera className="me-1" /> Drag the corners to select the area
// //               you want to keep. The image will be cropped to a perfect square.
// //             </div>
// //           </div>
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={cancelCrop}>
// //             <FaTimesCircle /> Cancel
// //           </Button>
// //           <Button variant="primary" onClick={applyCrop} className="crop-apply">
// //             <FaCrop /> Apply Crop
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     </>
// //   );
// // };

// // export default withAuth(ClientProfile, 'client');



// // src/pages/client/Profile/ClientProfile.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import Sidebar from '../../../components/layout/Sidebar';
// import './profile.scss';
// import withAuth from '../../auth/WithAuth';
// import defaultAvatar from '../../../assets/DefaultProfile.png';
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaLock,
//   FaCamera,
//   FaCheck,
//   FaExclamationTriangle,
//   FaEdit,
//   FaTimes,
//   FaTrash,
//   FaArrowRight,
//   FaCrop,
//   FaTimesCircle,
//   FaShieldAlt,
//   FaCheckCircle,
//   FaIdBadge,
// } from 'react-icons/fa';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import Alert from 'react-bootstrap/Alert';
// import Modal from 'react-bootstrap/Modal';
// import { serverUrlAuth } from '../../../serverUrl';
// import { useNavigate } from 'react-router-dom';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';

// const ClientProfile = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('profile');
//   const [profile, setProfile] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     avatar: defaultAvatar,
//   });
//   const [originalProfile, setOriginalProfile] = useState(profile);
//   const [editable, setEditable] = useState(false);
//   const [password, setPassword] = useState({
//     current: '',
//     new: '',
//     confirm: '',
//   });
//   const [alerts, setAlerts] = useState({ profile: '', password: '' });
//   const [isLoading, setIsLoading] = useState(false);
//   const fileInputRef = useRef(null);

//   const [showCropModal, setShowCropModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [crop, setCrop] = useState({
//     unit: '%',
//     width: 80,
//     height: 80,
//     x: 10,
//     y: 10,
//   });
//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [croppedImageUrl, setCroppedImageUrl] = useState(null);
//   const imgRef = useRef(null);

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const res = await serverUrlAuth.get('users/profile/');
//         const data = res.data;
//         const initialProfile = {
//           name: data.full_name,
//           email: data.email,
//           phone: data.phone_number || '',
//           avatar: data.profile_picture || defaultAvatar,
//         };
//         setProfile(initialProfile);
//         setOriginalProfile(initialProfile);
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchProfile();
//   }, []);

//   const toggleEdit = () => setEditable(true);

//   const cancelEdit = () => {
//     setProfile(originalProfile);
//     setEditable(false);
//   };

//   const handleDeleteAccountClick = () => {
//     navigate('/delete-account');
//   };

//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   const showAlert = (type, message, variant = 'success') => {
//     setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
//     setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
//   };

//   const handleAvatarChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (!file.type.startsWith('image/')) {
//         showAlert('profile', 'Please select a valid image', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showAlert('profile', 'Image must be less than 5MB', 'error');
//         return;
//       }

//       const reader = new FileReader();
//       reader.onload = () => {
//         setSelectedImage(reader.result);
//         setShowCropModal(true);
//         setCrop({ unit: '%', width: 80, height: 80, x: 10, y: 10 });
//         setCompletedCrop(null);
//         setCroppedImageUrl(null);
//       };
//       reader.readAsDataURL(file);
//       e.target.value = null;
//     }
//   };

//   const triggerFileInput = () => editable && fileInputRef.current?.click();

//   const onCropComplete = (crop) => {
//     setCompletedCrop(crop);
//   };

//   const getCroppedImg = async () => {
//     if (!imgRef.current || !completedCrop) return;

//     try {
//       const canvas = document.createElement('canvas');
//       const image = imgRef.current;
//       const crop = completedCrop;

//       const scaleX = image.naturalWidth / image.width;
//       const scaleY = image.naturalHeight / image.height;

//       canvas.width = crop.width * scaleX;
//       canvas.height = crop.height * scaleY;

//       const ctx = canvas.getContext('2d');
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';

//       ctx.drawImage(
//         image,
//         crop.x * scaleX,
//         crop.y * scaleY,
//         crop.width * scaleX,
//         crop.height * scaleY,
//         0,
//         0,
//         crop.width * scaleX,
//         crop.height * scaleY,
//       );

//       return new Promise((resolve) => {
//         canvas.toBlob(
//           (blob) => {
//             if (blob) {
//               const url = URL.createObjectURL(blob);
//               resolve(url);
//             }
//           },
//           'image/jpeg',
//           0.95,
//         );
//       });
//     } catch (error) {
//       console.error('Error cropping image:', error);
//       showAlert('profile', 'Failed to crop image', 'error');
//     }
//   };

//   const applyCrop = async () => {
//     if (!completedCrop) {
//       showAlert('profile', 'Please crop the image first', 'error');
//       return;
//     }

//     try {
//       const croppedImage = await getCroppedImg();
//       if (croppedImage) {
//         setCroppedImageUrl(croppedImage);
//         setProfile((prev) => ({ ...prev, avatar: croppedImage }));
//         showAlert('profile', 'Avatar cropped successfully!', 'success');
//         setShowCropModal(false);
//       }
//     } catch (error) {
//       console.error('Error applying crop:', error);
//       showAlert('profile', 'Failed to apply crop', 'error');
//     }
//   };

//   const cancelCrop = () => {
//     setShowCropModal(false);
//     setSelectedImage(null);
//     setCroppedImageUrl(null);
//     setCompletedCrop(null);
//   };

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPassword((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveProfile = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append('full_name', profile.name);
//       formData.append('phone_number', profile.phone);

//       if (croppedImageUrl) {
//         try {
//           const response = await fetch(croppedImageUrl);
//           const blob = await response.blob();
//           const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
//           formData.append('profile_picture', file);
//         } catch (error) {
//           console.error('Error converting cropped image:', error);
//           showAlert('profile', 'Error processing image', 'error');
//           setIsLoading(false);
//           return;
//         }
//       } else if (fileInputRef.current?.files[0]) {
//         formData.append('profile_picture', fileInputRef.current.files[0]);
//       }

//       const res = await serverUrlAuth.patch('users/profile/', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });

//       const updatedProfile = {
//         ...profile,
//         avatar: res.data.profile_picture || profile.avatar,
//       };

//       setProfile(updatedProfile);
//       setOriginalProfile(updatedProfile);
//       setCroppedImageUrl(null);
//       showAlert('profile', 'Profile updated successfully!', 'success');
//       setEditable(false);
//     } catch (error) {
//       console.error(error);
//       showAlert('profile', 'Failed to update profile', 'error');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const savePassword = async (e) => {
//     e.preventDefault();
//     if (password.new.length < 8)
//       return showAlert(
//         'password',
//         'Password must be at least 8 characters',
//         'error',
//       );
//     if (password.new !== password.confirm)
//       return showAlert('password', "Passwords don't match!", 'error');

//     setIsLoading(true);
//     await new Promise((resolve) => setTimeout(resolve, 1000));
//     setIsLoading(false);
//     showAlert('password', 'Password changed successfully!', 'success');
//     setPassword({ current: '', new: '', confirm: '' });
//   };

//   useEffect(() => {
//     return () => {
//       if (croppedImageUrl) {
//         URL.revokeObjectURL(croppedImageUrl);
//       }
//     };
//   }, [croppedImageUrl]);

//   return (
//     <>
//       <Sidebar />
//       <div className="modern-dashboard profile-shell">
//         <div className="profile-page">
//           {/* Hero */}
//           <header className="hero-craftsmanship">
//             <div className="hero-pattern"></div>
//             <div className="hero-content-modern">
//               <div className="welcome-badge">
//                 <FaIdBadge className="badge-icon" />
//                 <span>My Account</span>
//               </div>
//               <h1 className="hero-title">
//                 <span className="gradient-text">Manage Your</span>
//                 <span className="hero-accent">Profile</span>
//               </h1>
//               <p className="hero-subtitle">
//                 Update your personal details, avatar, and account settings —
//                 all in one place.
//               </p>
//             </div>
//           </header>

//           {/* Avatar floating between hero and card */}
//           <div className="avatar-float-wrap">
//             <div className={`avatar-float ${editable ? 'editable' : ''}`}>
//               <img src={profile.avatar} alt="Profile Avatar" />
//               {editable && (
//                 <>
//                   <button
//                     type="button"
//                     className="avatar-overlay-btn"
//                     onClick={triggerFileInput}
//                     aria-label="Change profile photo"
//                   >
//                     <FaCamera />
//                   </button>
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     onChange={handleAvatarChange}
//                     accept="image/*"
//                     style={{ display: 'none' }}
//                   />
//                 </>
//               )}
//             </div>
//             <div className="avatar-caption">
//               <h2>{profile.name || 'Your Name'}</h2>
//               <p>{profile.email || 'your@email.com'}</p>
//             </div>
//           </div>

//           {/* Main content */}
//           <div className="profile-layout">
//             <div className="profile-content">
//               {/* Alerts */}
//               {alerts.profile && alerts.profile.message && (
//                 <Alert
//                   variant={alerts.profile.variant}
//                   className="alert-custom"
//                 >
//                   {alerts.profile.variant === 'success' ? (
//                     <FaCheck />
//                   ) : (
//                     <FaExclamationTriangle />
//                   )}
//                   {alerts.profile.message}
//                 </Alert>
//               )}

//               {/* Tabs as pills in the card header */}
//               <div className="profile-card">
//                 <div className="card-tabs">
//                   <button
//                     className={`tab-pill ${
//                       activeTab === 'profile' ? 'active' : ''
//                     }`}
//                     onClick={() => setActiveTab('profile')}
//                   >
//                     <FaUser /> Profile
//                   </button>
//                   <button
//                     className={`tab-pill ${
//                       activeTab === 'password' ? 'active' : ''
//                     }`}
//                     onClick={() => setActiveTab('password')}
//                   >
//                     <FaLock /> Password
//                   </button>
//                 </div>

//                 <div className="card-header">
//                   <div className="header-title">
//                     <h3>
//                       {activeTab === 'profile'
//                         ? 'Profile Information'
//                         : 'Change Password'}
//                     </h3>
//                     <p>
//                       {activeTab === 'profile'
//                         ? 'Update your personal details and avatar'
//                         : 'Secure your account with a new password'}
//                     </p>
//                   </div>
//                   {activeTab === 'profile' && !editable && (
//                     <Button
//                       className="edit-profile"
//                       size="sm"
//                       onClick={toggleEdit}
//                     >
//                       <FaEdit /> Edit
//                     </Button>
//                   )}
//                 </div>

//                 {activeTab === 'profile' && (
//                   <div className="card-content profile-content-inner">
//                     <Form onSubmit={saveProfile}>
//                       <div className="section-label">
//                         <FaUser /> Personal Information
//                       </div>

//                       <Form.Group className="form-group-custom">
//                         <Form.Label>
//                           <FaUser className="input-icon" /> Full Name
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="name"
//                           value={profile.name}
//                           onChange={handleProfileChange}
//                           disabled={!editable}
//                           required
//                           placeholder="Enter your full name"
//                         />
//                       </Form.Group>

//                       <div className="form-row">
//                         <Form.Group className="form-group-custom">
//                           <Form.Label>
//                             <FaEnvelope className="input-icon" /> Email Address
//                           </Form.Label>
//                           <Form.Control
//                             type="email"
//                             name="email"
//                             value={profile.email}
//                             disabled
//                           />
//                           <small className="field-hint">
//                             <FaShieldAlt /> Email cannot be changed
//                           </small>
//                         </Form.Group>

//                         <Form.Group className="form-group-custom">
//                           <Form.Label>
//                             <FaPhone className="input-icon" /> Phone Number
//                           </Form.Label>
//                           <Form.Control
//                             type="tel"
//                             name="phone"
//                             value={profile.phone}
//                             onChange={handleProfileChange}
//                             disabled={!editable}
//                             placeholder="+254 7XX XXX XXX"
//                           />
//                         </Form.Group>
//                       </div>

//                       {editable && (
//                         <div className="form-actions">
//                           <Button
//                             className="save-profile"
//                             type="submit"
//                             disabled={isLoading}
//                           >
//                             {isLoading ? (
//                               'Saving...'
//                             ) : (
//                               <>
//                                 <FaCheck /> Save Changes
//                               </>
//                             )}
//                           </Button>
//                           <Button
//                             className="cancel-profile"
//                             variant="secondary"
//                             onClick={cancelEdit}
//                             disabled={isLoading}
//                           >
//                             <FaTimes /> Cancel
//                           </Button>
//                         </div>
//                       )}
//                     </Form>

//                     {/* Danger zone */}
//                     <div className="danger-zone">
//                       <div className="danger-text">
//                         <h4>
//                           <FaTrash /> Delete Account
//                         </h4>
//                         <p>
//                           Permanently delete your account and all associated
//                           data. This action cannot be undone.
//                         </p>
//                       </div>
//                       <button
//                         className="danger-btn"
//                         onClick={handleDeleteAccountClick}
//                         type="button"
//                       >
//                         Delete <FaArrowRight />
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {activeTab === 'password' && (
//                   <>
//                     {alerts.password && alerts.password.message && (
//                       <Alert
//                         variant={alerts.password.variant}
//                         className="alert-custom"
//                       >
//                         {alerts.password.variant === 'success' ? (
//                           <FaCheck />
//                         ) : (
//                           <FaExclamationTriangle />
//                         )}
//                         {alerts.password.message}
//                       </Alert>
//                     )}

//                     <div className="card-content password-content">
//                       <Form onSubmit={savePassword}>
//                         <div className="section-label">
//                           <FaShieldAlt /> Security
//                         </div>

//                         <Form.Group className="form-group-custom">
//                           <Form.Label>
//                             <FaLock className="input-icon" /> Current Password
//                           </Form.Label>
//                           <Form.Control
//                             type="password"
//                             name="current"
//                             value={password.current}
//                             onChange={handlePasswordChange}
//                             required
//                             placeholder="Enter current password"
//                           />
//                         </Form.Group>

//                         <Form.Group className="form-group-custom">
//                           <Form.Label>
//                             <FaLock className="input-icon" /> New Password
//                           </Form.Label>
//                           <Form.Control
//                             type="password"
//                             name="new"
//                             value={password.new}
//                             onChange={handlePasswordChange}
//                             required
//                             placeholder="At least 8 characters"
//                           />
//                         </Form.Group>

//                         <Form.Group className="form-group-custom">
//                           <Form.Label>
//                             <FaLock className="input-icon" /> Confirm New
//                             Password
//                           </Form.Label>
//                           <Form.Control
//                             type="password"
//                             name="confirm"
//                             value={password.confirm}
//                             onChange={handlePasswordChange}
//                             required
//                             placeholder="Re-enter new password"
//                           />
//                         </Form.Group>

//                         <div className="form-actions">
//                           <Button
//                             className="save-profile"
//                             type="submit"
//                             disabled={isLoading}
//                           >
//                             {isLoading ? (
//                               'Updating...'
//                             ) : (
//                               <>
//                                 <FaCheckCircle /> Change Password
//                               </>
//                             )}
//                           </Button>
//                         </div>
//                       </Form>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Crop Modal */}
//         <Modal
//           show={showCropModal}
//           onHide={cancelCrop}
//           size="lg"
//           centered
//           backdrop="static"
//           className="crop-modal-modern"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <FaCrop className="me-2" /> Crop Avatar Image
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="crop-container">
//               {selectedImage && (
//                 <ReactCrop
//                   crop={crop}
//                   onChange={(c) => setCrop(c)}
//                   onComplete={onCropComplete}
//                   aspect={1}
//                   circularCrop
//                   className="react-crop"
//                 >
//                   <img
//                     ref={imgRef}
//                     src={selectedImage}
//                     alt="Crop preview"
//                     onLoad={() => {
//                       const img = imgRef.current;
//                       if (img) {
//                         const { width, height } = img;
//                         const cropSize = Math.min(width, height) * 0.8;
//                         const cropX = (width - cropSize) / 2;
//                         const cropY = (height - cropSize) / 2;
//                         setCrop({
//                           unit: 'px',
//                           width: cropSize,
//                           height: cropSize,
//                           x: cropX,
//                           y: cropY,
//                         });
//                       }
//                     }}
//                   />
//                 </ReactCrop>
//               )}
//               <div className="crop-hint">
//                 <FaCamera className="me-1" /> Drag the corners to select the
//                 area you want to keep. The image will be cropped to a perfect
//                 square.
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={cancelCrop}>
//               <FaTimesCircle /> Cancel
//             </Button>
//             <Button variant="primary" onClick={applyCrop} className="crop-apply">
//               <FaCrop /> Apply Crop
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ClientProfile, 'client');


// src/pages/client/Profile/ClientProfile.jsx
import React, { useState, useEffect, useRef } from 'react';
import Sidebar from '../../../components/layout/Sidebar';
import './profile.scss';
import withAuth from '../../auth/WithAuth';
import defaultAvatar from '../../../assets/DefaultProfile.png';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaLock,
  FaCamera,
  FaCheck,
  FaExclamationTriangle,
  FaEdit,
  FaTimes,
  FaTrash,
  FaArrowRight,
  FaCrop,
  FaTimesCircle,
  FaShieldAlt,
  FaCheckCircle,
  FaIdBadge,
  FaEllipsisV,
} from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import { serverUrlAuth } from '../../../serverUrl';
import { useNavigate } from 'react-router-dom';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ClientProfile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('identity');
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
    avatar: defaultAvatar,
  });
  const [originalProfile, setOriginalProfile] = useState(profile);
  const [editable, setEditable] = useState(false);
  const [password, setPassword] = useState({
    current: '',
    new: '',
    confirm: '',
  });
  const [alerts, setAlerts] = useState({ profile: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ unit: '%', width: 80, height: 80, x: 10, y: 10 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await serverUrlAuth.get('users/profile/');
        const data = res.data;
        const initialProfile = {
          name: data.full_name,
          email: data.email,
          phone: data.phone_number || '',
          avatar: data.profile_picture || defaultAvatar,
        };
        setProfile(initialProfile);
        setOriginalProfile(initialProfile);
      } catch (error) {
        console.error(error);
      }
    };
    fetchProfile();
  }, []);

  const toggleEdit = () => setEditable(true);

  const cancelEdit = () => {
    setProfile(originalProfile);
    setEditable(false);
  };

  const handleDeleteAccountClick = () => navigate('/delete-account');

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const showAlert = (type, message, variant = 'success') => {
    setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
    setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showAlert('profile', 'Please select a valid image', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showAlert('profile', 'Image must be less than 5MB', 'error');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
        setShowCropModal(true);
        setCrop({ unit: '%', width: 80, height: 80, x: 10, y: 10 });
        setCompletedCrop(null);
        setCroppedImageUrl(null);
      };
      reader.readAsDataURL(file);
      e.target.value = null;
    }
  };

  const triggerFileInput = () => editable && fileInputRef.current?.click();

  const onCropComplete = (crop) => setCompletedCrop(crop);

  const getCroppedImg = async () => {
    if (!imgRef.current || !completedCrop) return;
    try {
      const canvas = document.createElement('canvas');
      const image = imgRef.current;
      const crop = completedCrop;
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width * scaleX;
      canvas.height = crop.height * scaleY;
      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY,
      );
      return new Promise((resolve) => {
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const url = URL.createObjectURL(blob);
              resolve(url);
            }
          },
          'image/jpeg',
          0.95,
        );
      });
    } catch (error) {
      console.error('Error cropping image:', error);
      showAlert('profile', 'Failed to crop image', 'error');
    }
  };

  const applyCrop = async () => {
    if (!completedCrop) {
      showAlert('profile', 'Please crop the image first', 'error');
      return;
    }
    try {
      const croppedImage = await getCroppedImg();
      if (croppedImage) {
        setCroppedImageUrl(croppedImage);
        setProfile((prev) => ({ ...prev, avatar: croppedImage }));
        showAlert('profile', 'Avatar cropped successfully!', 'success');
        setShowCropModal(false);
      }
    } catch (error) {
      console.error('Error applying crop:', error);
      showAlert('profile', 'Failed to apply crop', 'error');
    }
  };

  const cancelCrop = () => {
    setShowCropModal(false);
    setSelectedImage(null);
    setCroppedImageUrl(null);
    setCompletedCrop(null);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword((prev) => ({ ...prev, [name]: value }));
  };

  const saveProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('full_name', profile.name);
      formData.append('phone_number', profile.phone);
      if (croppedImageUrl) {
        try {
          const response = await fetch(croppedImageUrl);
          const blob = await response.blob();
          const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
          formData.append('profile_picture', file);
        } catch (error) {
          console.error('Error converting cropped image:', error);
          showAlert('profile', 'Error processing image', 'error');
          setIsLoading(false);
          return;
        }
      } else if (fileInputRef.current?.files[0]) {
        formData.append('profile_picture', fileInputRef.current.files[0]);
      }
      const res = await serverUrlAuth.patch('users/profile/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const updatedProfile = {
        ...profile,
        avatar: res.data.profile_picture || profile.avatar,
      };
      setProfile(updatedProfile);
      setOriginalProfile(updatedProfile);
      setCroppedImageUrl(null);
      showAlert('profile', 'Profile updated successfully!', 'success');
      setEditable(false);
    } catch (error) {
      console.error(error);
      showAlert('profile', 'Failed to update profile', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    if (password.new.length < 8)
      return showAlert('password', 'Password must be at least 8 characters', 'error');
    if (password.new !== password.confirm)
      return showAlert('password', "Passwords don't match!", 'error');
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsLoading(false);
    showAlert('password', 'Password changed successfully!', 'success');
    setPassword({ current: '', new: '', confirm: '' });
  };

  useEffect(() => {
    return () => {
      if (croppedImageUrl) URL.revokeObjectURL(croppedImageUrl);
    };
  }, [croppedImageUrl]);

  // Initials fallback if avatar fails
  const initials = (profile.name || 'U')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard id-card-shell">
        <div className="id-card-page">
          {/* ============================================================
              IDENTITY POSTER — avatar, name, meta, tabs as bottom rail
             ============================================================ */}
          <section className="identity-poster">
            <div className="poster-backdrop">
              <span className="poster-blob poster-blob-1" />
              <span className="poster-blob poster-blob-2" />
              <span className="poster-blob poster-blob-3" />
              <span className="poster-grid" />
            </div>

            <div className="poster-inner">
              {/* Left: avatar */}
              <div className="poster-avatar">
                <div className="avatar-shell">
                  <img
                    src={profile.avatar}
                    alt={profile.name || 'Avatar'}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                  <span className="avatar-initials">{initials}</span>
                  {editable && (
                    <button
                      type="button"
                      className="avatar-trigger"
                      onClick={triggerFileInput}
                      aria-label="Change profile photo"
                    >
                      <FaCamera />
                      <span>Change</span>
                    </button>
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleAvatarChange}
                    accept="image/*"
                    style={{ display: 'none' }}
                  />
                </div>
                
              </div>

              {/* Right: identity text */}
              <div className="poster-info">
                <span className="poster-eyebrow">
                  <FaIdBadge /> Client Identity
                </span>
                <h1 className="poster-name">
                  {profile.name || 'Your Name'}
                </h1>
                <div className="poster-contact">
                  <span className="contact-chip">
                    <FaEnvelope /> {profile.email || '—'}
                  </span>
                  <span className="contact-chip">
                    <FaPhone /> {profile.phone || 'Not added'}
                  </span>
                </div>

               
              </div>
            </div>

            {/* Segmented tab rail — floats at bottom of poster */}
            <nav className="segmented-rail" aria-label="Profile sections">
              <button
                className={`seg-btn ${activeTab === 'identity' ? 'active' : ''}`}
                onClick={() => setActiveTab('identity')}
              >
                <FaUser /> <span>Identity</span>
              </button>
              <button
                className={`seg-btn ${activeTab === 'security' ? 'active' : ''}`}
                onClick={() => setActiveTab('security')}
              >
                <FaLock /> <span>Security</span>
              </button>
              <button
                className="seg-btn danger"
                onClick={handleDeleteAccountClick}
              >
                <FaTrash /> <span>Delete</span>
              </button>
            </nav>
          </section>

          {/* ============================================================
              CONTENT AREA
             ============================================================ */}
          <div className="id-content">
            {/* Alerts */}
            {alerts.profile && alerts.profile.message && (
              <Alert variant={alerts.profile.variant} className="id-alert">
                {alerts.profile.variant === 'success' ? <FaCheck /> : <FaExclamationTriangle />}
                {alerts.profile.message}
              </Alert>
            )}
            {alerts.password && alerts.password.message && (
              <Alert variant={alerts.password.variant} className="id-alert">
                {alerts.password.variant === 'success' ? <FaCheck /> : <FaExclamationTriangle />}
                {alerts.password.message}
              </Alert>
            )}

            {/* ===================== IDENTITY TAB ===================== */}
            {activeTab === 'identity' && (
              <section className="id-card">
                {/* Card top strip */}
                <div className="card-strip">
                  <div className="strip-left">
                    <span className="strip-icon"><FaUser /></span>
                    <div>
                      <h2>Personal Information</h2>
                      <p>
                        {editable
                          ? 'Update your details — changes save when you click Save.'
                          : 'These are the details clients see when you reach out.'}
                      </p>
                    </div>
                  </div>
                  {!editable && (
                    <button className="btn-icon-edit" onClick={toggleEdit}>
                      <FaEdit /> <span>Edit</span>
                    </button>
                  )}
                </div>

                {/* Body: read mode vs edit mode */}
                <Form onSubmit={saveProfile} className="card-body">
                  {!editable ? (
                    // ---- READ MODE: passport-style label/value rows ----
                    <div className="read-sheet">
                      <div className="read-row">
                        <div className="read-key">
                          <FaUser className="read-icon" />
                          <span>Full Name</span>
                        </div>
                        <div className="read-val">
                          {profile.name || '—'}
                        </div>
                      </div>

                      <div className="read-row">
                        <div className="read-key">
                          <FaEnvelope className="read-icon" />
                          <span>Email</span>
                        </div>
                        <div className="read-val">
                          {profile.email || '—'}
                          <span className="lock-tag">
                            <FaLock /> Locked
                          </span>
                        </div>
                      </div>

                      <div className="read-row">
                        <div className="read-key">
                          <FaPhone className="read-icon" />
                          <span>Phone Number</span>
                        </div>
                        <div className="read-val">
                          {profile.phone || (
                            <span className="muted">Not added yet</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    // ---- EDIT MODE: three stacked fields ----
                    <div className="edit-sheet">
                      <div className="edit-field">
                        <label htmlFor="name">
                          <FaUser /> Full Name
                        </label>
                        <input
                          id="name"
                          type="text"
                          name="name"
                          value={profile.name}
                          onChange={handleProfileChange}
                          placeholder="Enter your full name"
                          required
                          autoFocus
                        />
                      </div>

                      <div className="edit-field">
                        <label htmlFor="email">
                          <FaEnvelope /> Email Address
                        </label>
                        <input
                          id="email"
                          type="email"
                          name="email"
                          value={profile.email}
                          disabled
                        />
                        <small className="field-hint">
                          <FaShieldAlt /> Email can't be changed here
                        </small>
                      </div>

                      <div className="edit-field">
                        <label htmlFor="phone">
                          <FaPhone /> Phone Number
                        </label>
                        <input
                          id="phone"
                          type="tel"
                          name="phone"
                          value={profile.phone}
                          onChange={handleProfileChange}
                          placeholder="+254 7XX XXX XXX"
                        />
                      </div>

                      <div className="edit-actions">
                        <button
                          type="button"
                          className="btn-ghost"
                          onClick={cancelEdit}
                          disabled={isLoading}
                        >
                          <FaTimes /> Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn-solid"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>Saving…</>
                          ) : (
                            <>
                              <FaCheck /> Save Changes
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </Form>
              </section>
            )}

            {/* ===================== SECURITY TAB ===================== */}
            {activeTab === 'security' && (
              <section className="id-card">
                <div className="card-strip">
                  <div className="strip-left">
                    <span className="strip-icon"><FaLock /></span>
                    <div>
                      <h2>Change Password</h2>
                      <p>
                        Use a strong password with at least 8 characters,
                        including numbers and symbols.
                      </p>
                    </div>
                  </div>
                </div>

                <Form onSubmit={savePassword} className="card-body">
                  <div className="edit-sheet">
                    <div className="edit-field">
                      <label htmlFor="current">
                        <FaLock /> Current Password
                      </label>
                      <input
                        id="current"
                        type="password"
                        name="current"
                        value={password.current}
                        onChange={handlePasswordChange}
                        placeholder="Enter current password"
                        required
                      />
                    </div>

                    <div className="edit-field">
                      <label htmlFor="new">
                        <FaShieldAlt /> New Password
                      </label>
                      <input
                        id="new"
                        type="password"
                        name="new"
                        value={password.new}
                        onChange={handlePasswordChange}
                        placeholder="At least 8 characters"
                        required
                      />
                    </div>

                    <div className="edit-field">
                      <label htmlFor="confirm">
                        <FaCheckCircle /> Confirm New Password
                      </label>
                      <input
                        id="confirm"
                        type="password"
                        name="confirm"
                        value={password.confirm}
                        onChange={handlePasswordChange}
                        placeholder="Re-enter new password"
                        required
                      />
                    </div>

                    <div className="edit-actions">
                      <button
                        type="submit"
                        className="btn-solid"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>Updating…</>
                        ) : (
                          <>
                            <FaCheckCircle /> Update Password
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </Form>
              </section>
            )}

            {/* ===================== DANGER ENVELOPE ===================== */}
            {activeTab === 'identity' && (
              <section className="sealed-envelope">
                <div className="sealed-inner">
                  <div className="sealed-stamp">
                    <FaTrash />
                  </div>
                  <div className="sealed-text">
                    <h3>Delete Account</h3>
                    <p>
                      This permanently removes your account, projects, and all
                      associated data. <strong>Cannot be undone.</strong>
                    </p>
                  </div>
                  <button
                    type="button"
                    className="sealed-btn"
                    onClick={handleDeleteAccountClick}
                  >
                    <span>Proceed</span>
                    <FaArrowRight />
                  </button>
                </div>
              </section>
            )}
          </div>
        </div>

        {/* Crop Modal */}
        <Modal
          show={showCropModal}
          onHide={cancelCrop}
          size="lg"
          centered
          backdrop="static"
          className="crop-modal-modern"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaCrop className="me-2" /> Crop Avatar Image
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="crop-container">
              {selectedImage && (
                <ReactCrop
                  crop={crop}
                  onChange={(c) => setCrop(c)}
                  onComplete={onCropComplete}
                  aspect={1}
                  circularCrop
                  className="react-crop"
                >
                  <img
                    ref={imgRef}
                    src={selectedImage}
                    alt="Crop preview"
                    onLoad={() => {
                      const img = imgRef.current;
                      if (img) {
                        const { width, height } = img;
                        const cropSize = Math.min(width, height) * 0.8;
                        const cropX = (width - cropSize) / 2;
                        const cropY = (height - cropSize) / 2;
                        setCrop({
                          unit: 'px',
                          width: cropSize,
                          height: cropSize,
                          x: cropX,
                          y: cropY,
                        });
                      }
                    }}
                  />
                </ReactCrop>
              )}
              <div className="crop-hint">
                <FaCamera className="me-1" /> Drag the corners to select the
                area you want to keep. The image will be cropped to a perfect
                square.
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={cancelCrop}>
              <FaTimesCircle /> Cancel
            </Button>
            <Button variant="primary" onClick={applyCrop} className="crop-apply">
              <FaCrop /> Apply Crop
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ClientProfile, 'client');